module.exports = __webpack_public_path__ + "img/contentImgHover2.aff9f58.png";